// tslint:disable-next-line:eofline
export * from './material.module';
